module.exports = __webpack_public_path__ + "img/3.f03c9bfb.jpg";